import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/stats/site`;
const CLE_SESSION = "fodindinca_session";
const RAFRAICHISSEMENT_MS = 30000; // compteurs
const PING_MS = 60000; // présence « en ligne »

const VIDE = {
  aujourdhui: { visiteurs_uniques: 0, pages_vues: 0 },
  en_ligne: { nombre: 0, libelle: "personnes en ligne" },
  global: { visiteurs_total: 0, pages_vues_total: 0 },
};

/** Compteur global de visiteurs : ping de présence + rafraîchissement périodique.
 *  Aucune dépendance temps réel ajoutée : le ping (60 s) maintient la session
 *  « en ligne » côté serveur, la lecture (30 s) met à jour l'affichage. */
export const useSiteStats = ({ actif = true, suivre = true, avecPointe = false } = {}) => {
  const [stats, setStats] = useState(VIDE);
  const [pointe, setPointe] = useState(null);
  const [charge, setCharge] = useState(false);
  const sessionRef = useRef(
    typeof window !== "undefined" ? localStorage.getItem(CLE_SESSION) : null
  );

  const lire = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/current`);
      if (data?.ok) {
        setStats(data.data);
        setCharge(true);
      }
    } catch {
      /* le compteur ne doit jamais casser la page */
    }
  }, []);

  const ping = useCallback(async () => {
    try {
      const { data } = await axios.post(`${API}/ping`, {
        session_id: sessionRef.current,
        chemin: window.location.pathname,
      });
      if (data?.session_id) {
        sessionRef.current = data.session_id;
        localStorage.setItem(CLE_SESSION, data.session_id);
      }
    } catch {
      /* ignoré */
    }
  }, []);

  const lirePointe = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/pointe`);
      if (data?.ok) setPointe(data.data);
    } catch {
      /* ignoré */
    }
  }, []);

  useEffect(() => {
    if (!actif) return undefined;
    if (suivre) ping();
    if (avecPointe) lirePointe();
    lire();
    const idLecture = setInterval(lire, RAFRAICHISSEMENT_MS);
    const idPing = suivre ? setInterval(ping, PING_MS) : null;
    return () => {
      clearInterval(idLecture);
      if (idPing) clearInterval(idPing);
    };
  }, [actif, suivre, lire, ping, avecPointe, lirePointe]);

  return { stats, pointe, charge, rafraichir: lire, chargerPointe: lirePointe };
};

export default useSiteStats;
